import normalizeProjectId from '@/lib/normalizeProjectId.js';

const getThreadProjectId = (thread = {}) => {
  return normalizeProjectId(thread?.projectId || thread?.project?.id || thread?.project?.projectId || thread?.project_id);
};

export default getThreadProjectId;
